module.exports = __webpack_public_path__ + "static/media/Novonordisk.77d1a3a0.jpg";